import React from 'react';
import classNames from 'classnames';

import css from './Ingress.module.css';

/**
 * Ingress: a lead paragraph or an opening paragraph
 * It's usually between a headline and the article
 *
 * @component
 * @param {Object} props
 * @param {string?} props.className add more style rules in addition to components own css.root
 * @param {string?} props.rootClassName overwrite components own css.root
 * @param {ReactNode} props.children
 * @returns {JSX.Element} ingress (using 'p' element)
 */
export const Ingress = React.forwardRef((props, ref) => {
  const { className, rootClassName, children, ...otherProps } = props;
  const classes = classNames(rootClassName || css.ingress, className);

  // Support line breaks: if children is a string containing a newline,
  // split it into separate lines with <br> between them.
  // The last line gets a slightly larger font size via css.lastLine.
  if (typeof children === 'string' && children.includes('\n')) {
    const lines = children.split('\n');
    return (
      <p className={classes} {...otherProps} ref={ref}>
        {lines.map((line, i) => (
          <React.Fragment key={i}>
            {i === lines.length - 1 ? (
              <span className={css.lastLine}>{line}</span>
            ) : (
              <>
                {line}
                <br />
              </>
            )}
          </React.Fragment>
        ))}
      </p>
    );
  }

  return <p className={classes} {...otherProps} ref={ref}>{children}</p>;
});

Ingress.displayName = 'Ingress';
